/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Attributes have been pasted successfully" |
*
* @param {Paste_Attributes_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_success_toast = /** @type {((inputs?: Paste_Attributes_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attributs colles avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Attribute wurden erfolgreich eingefügt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli attributi sono stati incollati correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Атрибуты успешно вставлены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los atributos se han pegado correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("属性已成功粘贴")
	if (locale === "ja") return /** @type {LocalizedString} */ ("属性が正常に貼り付けられました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विशेषताएँ सफलतापूर्वक पेस्ट कर दी गई हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os atributos foram colados com sucesso.")
	return /** @type {LocalizedString} */ ("Attributes have been pasted successfully")
});